import { Text } from '../../../components';
import React from 'react';
import {
  DotIconStyle,
  MeetingItemRightStyle,
  MeetingItemStyle,
} from '../styles';
import { DotIcon } from '../../../components/icons';
import { theme } from '@repo-sapiens/theme';
import { css } from '@emotion/css';

type Props = {
  title: string;
  startTime: string;
  noLink?: boolean;
  hasTranscript?: boolean;
  filtered?: boolean;
  onClick?: () => void;
};
export const TranscriptListItem: React.FC<Props> = ({
  title,
  startTime,
  noLink = false,
  hasTranscript,
  filtered,
  onClick,
}) => {
  return (
    <div
      className={MeetingItemStyle}
      style={{
        cursor: noLink ? 'default' : 'pointer',
      }}
      onClick={onClick}
    >
      <div>
        <Text.BodyXS>
          {title}
          {filtered && (
            <span
              className={css`
                color: ${theme.colors.text['highlight/1']};
              `}
            >
              *
            </span>
          )}
        </Text.BodyXS>
      </div>
      <div className={MeetingItemRightStyle}>
        <Text.BodyXS color="tertiary">{startTime}</Text.BodyXS>
        <DotIcon fill="tertiary" style={DotIconStyle} />
        {noLink ? (
          <Text.BodyXS color="tertiary">No transcript</Text.BodyXS>
        ) : hasTranscript ? (
          <Text.BodyXS color="highlight/1">See transcript</Text.BodyXS>
        ) : (
          <Text.BodyXS color="highlight/3">See Meeting prep</Text.BodyXS>
        )}
      </div>
    </div>
  );
};
